import React, { useContext } from 'react';
import { LanguageContext, ThemeContext } from '../App';

// compact: versión para la barra superior (AdjusterShell): ES/EN y, en
// pantallas angostas, solo el icono del tema (el nombre queda en aria-label).
export default function WorkspacePreferences({ compact = false }) {
  const { theme, toggleTheme } = useContext(ThemeContext);
  const { language, setLanguage } = useContext(LanguageContext);
  const es = language === 'es';
  return <div className={`workspace-preferences ${compact ? 'is-compact' : ''}`}>
    <button type="button" onClick={toggleTheme} aria-label={es ? (theme === 'dark' ? 'Activar modo claro' : 'Activar modo oscuro') : (theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode')}>
      <i className={`fa-regular ${theme === 'dark' ? 'fa-sun' : 'fa-moon'}`} aria-hidden="true" />
      <span className="wp-label">{theme === 'dark' ? (es ? 'Modo claro' : 'Light mode') : (es ? 'Modo oscuro' : 'Dark mode')}</span>
    </button>
    <select aria-label={es ? 'Idioma' : 'Language'} value={language} onChange={event => {
      setLanguage(event.target.value);
      localStorage.setItem('userLanguage', event.target.value);
    }}><option value="es">{compact ? 'ES' : 'Español'}</option><option value="en">{compact ? 'EN' : 'English'}</option></select>
  </div>;
}
